import { Card, Typography } from 'antd';
import { ReportLegendItem } from './CorporateReportInfoBanner';

interface CorporateReportLegendSidebarProps {
  items: ReportLegendItem[];
  title?: string;
  fullWidth?: boolean;
}

export const CorporateReportLegendSidebar = ({
  items,
  title = 'Legenda',
  fullWidth = false
}: CorporateReportLegendSidebarProps) => {
  return (
    <Card
      size="small"
      className={`shrink-0 rounded-xl border-slate-200 shadow-sm ${
        fullWidth ? 'w-full' : 'w-full lg:w-72'
      }`}
      title={<Typography.Text strong>{title}</Typography.Text>}
    >
      <ul className="m-0 list-none space-y-4 pl-0">
        {items.map(item => (
          <li key={item.label} className="flex gap-3">
            {item.icon && (
              <div
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-base ${
                  item.iconClassName || 'bg-violet-100 text-violet-700'
                }`}
              >
                {item.icon}
              </div>
            )}
            <div>
              <Typography.Text strong className="block text-sm">
                {item.label}
              </Typography.Text>
              <Typography.Text
                type="secondary"
                className="whitespace-pre-line text-xs leading-snug"
              >
                {item.description}
              </Typography.Text>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};
